var React = require('react');

function Sun (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50.5 101C78.3904 101 101 78.3904 101 50.5C101 22.6096 78.3904 0 50.5 0C22.6096 0 0 22.6096 0 50.5C0 78.3904 22.6096 101 50.5 101Z","fill":"#FFC907"}));
}

Sun.defaultProps = {"width":"101","height":"101","viewBox":"0 0 101 101","fill":"none"};

module.exports = Sun;

Sun.default = Sun;
